var _clipPath, _clipPath2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSrb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 672.1,
    viewBox: "0 0 756.1 504.1",
    width: 1008.2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 167.8h756.1V336H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 335.5h756.1v168.6H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h756.1v504H0Z",
    style: {
      fill: "#c6363c",
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 1.73203361
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.9975 0 -167.2)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0c4076",
      fillOpacity: 1
    },
    fillRule: "evenodd",
    fill: "#0d4077",
    d: "M0 167.6h756.1v168.5H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M0 334.8h756.1V504H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f",
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-76.3 345.7c2.3.7 5.4-.5 6-1 .4-.2 1.2.3 1.6.4 10.8 5.8 11.6 5.8 14.7.5a85.5 85.5 0 0 0 6.1-22.4c1-1.7 2.4-2.8 3.5-4.3a68.4 68.4 0 0 1-8.4 37.4c-2.9 4.4-10.3.5-21.5-4-3-3.4-4.4-5-2-6.6z",
    transform: "matrix(.12583 -1 .99997 .12583 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66166002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-338.2-120.6c-.3.9-.6 1.8-.7 2.6-.3 1.5-.2 3 .3 4.5-1.6 2.3-3.5 4.8-4.8 7.3-1 1.8-1.7 3.8-1.2 5.8.6 2.2 2.5 3.6 4.2 5 2.1 1.5 4.8 2.9 7.6 4a45 45 0 0 0 14.7 4l-2.3-2.1c-6.7-2.2-14.6-5-18.4-8-5-3.7-4.8-4.6 2.3-14.7.2-.3.8-1 .6-1.4-.4-.8-1-4 0-6.4-.6-1.1-1.5-.5-2.3-.6z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-277.8-75.9c0 1.3 0 1.1-.2-.9-.2.4-.5.6-.8.6-.6 0-1-.9-1-2.9l.1-1.5c-18.3.4-29.2-2.3-32-7.6-2.3-4.4 1.6-11.6 7.5-19.9.8-1 .7-.9 0-1.7-1-1.2-2-3.2-1.2-5-3.6-2-7.9-2.4-11.6-.8-.6 1.6-2 2.4-3 3.1-.3.2-1 .6-1.1.8-2 6.3-4 12-5.6 17.4-5.3 17 41.7 18.5 48.9 18.4z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.2-148.5c1.8 3.7 3.7 7.2 6.2 10.3-6.5-4.8-9.9-4-10.4 2.2l-1.4.1c-5-7.7-9.8-6.6-14.5 3.2-6.4-10-11.9-9.9-16.2.6-7.4-9.2-13.6-9.2-18.6-.2v1.2c.3-.1 0-.2-.6 0l-.1.1h-1.1l-.1-.2h-.6v-1c-5-9.1-11.2-9-18.6.1-4.3-10.5-9.8-10.7-16.2-.6-4.7-9.8-9.6-10.9-14.5-3.2l-1.4-.1c-.5-6.3-4-7-10.5-2.2 2.6-3 4.5-6.6 6.3-10.3 18.8.8 37.5 1.8 56.1 2.8 18.7-1 37.4-2 56.2-2.8z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.9-133.4-2 .4c-4-9.6-7.5-9.8-8.2-.7 1 .3.6 1.8 1.6 1.2.5-.3 1.1.6.7 1.1-1.1.8-2 .7-3-.2-.5 1.4-1.6 2.1-3 1.5-.6-.3-.4-1.4.2-1.3 1 .1.6-1 .9-1.6-7-9-10.5-8-9.7 4-1.6.3-3.6.6-5.3 1.2-6.4-12.8-11-13.4-14.6-1.8.8.5.5 2 1.7 1.5.6-.2 1.2 1 .6 1.4-1.3 1.1-2.8.8-3.8-.7-.8 1.6-2.2 2.1-3.7 1.2-.6-.4-.2-1.6.5-1.4 1.3.3.7-1.4 1.7-2-2.8-10.8-17.1-11.6-14.8 4.5l-3.7-.2-3.6.2c2.3-16-12-15.3-14.8-4.5 1 .6.4 2.3 1.7 2 .7-.2 1 1 .4 1.4-1.4 1-2.8.4-3.6-1.2-1 1.5-2.5 1.8-3.8.7-.6-.5 0-1.6.6-1.4 1.2.5 1-1 1.7-1.5-3.7-11.6-8.2-11-14.6 1.8-1.7-.6-3.7-1-5.3-1.3.8-11.9-2.7-13-9.7-3.9.3.7 0 1.7 1 1.6.5 0 .7 1 .1 1.3-1.4.6-2.5 0-3-1.5-1 .9-2 1-3 .2-.5-.5.2-1.4.7-1 1 .5.7-1 1.5-1.3-.6-9.1-4.1-8.9-8 .7l-2-.4c-.2-2.2.6-4.6 2-6.4 5.9-7.4 10.3-5.7 10.4 2.6 7.7-9 13.6-7.8 14.6 1.7 6.5-12 16.9-6.3 17 1 3-10.6 18.7-10.5 19.7 1.6 1-12.1 16.9-12.2 19.7-1.6.2-7.3 10.6-13 17-1 1.1-9.5 7-10.7 14.7-1.7.1-8.3 4.5-10 10.4-2.6 1.4 1.8 2.1 4.2 2 6.4z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M121.7 283.2c-.6-.9-.4-1-.8-1.3-.4-.4-1.2-.4-2-.3-2.8.5-2.4-1.3-1.1-3.2.6-1 2.1-2 2.9-2.8.8-.9.8-1.6 1.1-1.8h5.1c.3.2.4 1 1.2 1.8.7.8 2.2 1.8 2.9 2.8 1.3 2 1.7 3.7-1.2 3.2-.8 0-1.5 0-2 .3-.3.3-.2.4-.7 1.3-.4.6-.8 1-1.3 1.3-.4.2-1 0-1.4 0-.5 0-1 .2-1.5 0-.4-.3-.9-.7-1.2-1.3z",
    transform: "matrix(0 .99572 1 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66692001,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "M273.7 124.3v.5c2.2.2 3.9 1 5.4 2.4-1-1.5-3.1-2.6-5.4-3M273.7 123.4v-.5c2.2-.3 3.9-1 5.4-2.4-1 1.5-3.1 2.6-5.4 2.9",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-117.2 281.7c-.2-.7-.5-1.4-1-2-.9-.8-2.3-.2-3.7.9-.4.4-1.2.5-2 .5-.7 0-1.5-.1-1.9-.5-1.4-1.1-2.8-1.7-3.6-.8-.6.5-.9 1.2-1.1 1.9h1.3c.7-.2 1.5-.2 2 .2.3.3.1.4.7 1.3.3.6.8 1 1.2 1.3.5.3 1 .1 1.5.1s1 .2 1.4-.1c.5-.3.9-.7 1.2-1.3.6-.9.4-1 .8-1.3.5-.4 1.2-.4 2-.3h1.3z",
    transform: "matrix(0 -1 .99997 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-143.2-186c2.3.7 5.4-.5 6-1 .4-.1 1.2.3 1.6.5 10.7 5.8 11.6 5.8 14.7.4a85.5 85.5 0 0 0 6.1-22.4c1-1.6 2.4-2.8 3.5-4.2a68.4 68.4 0 0 1-8.4 37.3c-2.9 4.4-10.3.5-21.5-4-3-3.4-4.4-4.9-2-6.6z",
    transform: "matrix(-.12583 -1 -.99997 .12583 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66166002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9-120.6c-.4.9-.6 1.8-.7 2.6-.3 1.5-.2 3 .3 4.5-1.7 2.3-3.5 4.8-4.8 7.3-1 1.8-1.7 3.8-1.2 5.8.6 2.2 2.5 3.6 4.2 5 2 1.5 4.8 2.9 7.6 4a45 45 0 0 0 14.7 4l-2.3-2.1c-6.7-2.2-14.6-5-18.4-8-5-3.7-4.8-4.6 2.3-14.7.2-.3.8-1 .6-1.4-.4-.8-1-4 0-6.4-.6-1.1-1.5-.5-2.3-.6z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.3-75.9c0 1.3 0 1.1-.2-.9-.2.4-.5.6-.8.6-.6 0-1-.9-1-2.9v-1.5c-18.2.4-29.1-2.3-31.9-7.6-2.3-4.4 1.6-11.6 7.5-19.9.7-1 .7-.9 0-1.7-1-1.2-2-3.2-1.2-5-3.6-2-7.9-2.4-11.6-.8-.6 1.6-2 2.4-3 3.1-.3.2-1 .6-1.1.8-2 6.3-4 12-5.6 17.4-5.3 17 41.7 18.5 48.9 18.4z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.2-278 15.8-6-19-49.9-15.8 3a766.8 766.8 0 0 0 19 52.9z",
    transform: "matrix(-.41558 1 -.99998 -.41558 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.61581999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M265.5-145.7v-.1c-9.7-.4-26.9-1.4-51.6-3l3.6-17 52.5 1.6 52.6-1.6 3.6 17c-24.7 1.6-41.9 2.6-51.6 3 1 .3-.5.3-4.6.2-4 .1-5.5 0-4.5-.1z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-147.7H262l-.7-.1h-4.4l-.3-.1H253v-.1h-2.6l-.7-.1h-2l-3.5-.2h-.1l-5.1-.3h-.4l-10.1-.7h-.1l-14.7-1.3c-2.7-.3-3.2 3 0 3.3l14.6 1.3c6.8.5 13.6.9 20.5 1.1h1.5c2.9.2 5.7.3 8.6.3H262.3l1.8.1H281.3l8.5-.3H291.5a523 523 0 0 0 35-2.5c3.3-.3 2.8-3.6 0-3.3-4.8.5-9.6 1-14.5 1.3h-.2l-10.1.7h-.3c-1.8 0-3.5.2-5.2.3h-.1l-3.5.1h-1.9l-.7.1H288l-.8.1h-1.3l-2.3.1H279l-.2.1H270z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.3-107.7a3.5 3.5 0 1 0 0-7.1 3.5 3.5 0 0 0 0 7z",
    transform: "matrix(.99998 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66698003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.2-115.1a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.1-109.1a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.2-103a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.5z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M270-119.6a4.3 4.3 0 1 0 0-8.5 4.3 4.3 0 0 0 0 8.5z",
    transform: "matrix(.99998 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66716999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4-130.6c2 0 1.2-3.3.8-4-.6-1-1-1-1.6 0-.4.7-1 4 .8 4z",
    transform: "matrix(.99925 -.06748 -.06753 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66689003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2-132.4c4.5 0 2.9-7.8 1.9-9.5-1.3-2.2-2.4-2.2-3.7 0-1 1.7-2.6 9.5 1.8 9.5z",
    transform: "matrix(.99997 -.06753 -.06753 -1 0 .1)",
    style: {
      fill: "#fff",
      stroke: "#21231e",
      strokeWidth: 0.66535997,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4-169.8c1.8 0 1.1-3.2.7-3.8-.5-1-1-1-1.5 0-.4.6-1 3.8.8 3.8z",
    transform: "matrix(.99924 -.31799 -.3182 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.63694,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.3-171.5c4.2 0 2.7-7.5 1.7-9.1-1.2-2.1-2.2-2.1-3.5 0-1 1.6-2.5 9 1.8 9z",
    transform: "matrix(.99997 -.31822 -.31821 -1 0 .1)",
    style: {
      fill: "#fff",
      stroke: "#21231e",
      strokeWidth: 0.63547999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.1-79c-9.5 1-19.3 0-29-3.9-8.1-3.2-7.3-12.6 2.6-25.8-.9-1.6-1.4-3.7-1.5-6h2.7c-.7 1.6.1 3.5 1 4.9.6.9.7.7 0 1.7-5.9 8.3-9.8 15.5-7.5 19.9 2.8 5.3 13.7 8 32 7.6l-.1 1.5-.2.2z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.8-81.6a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.4-79.4a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m221.3-82.3 1-1.4c-5.3-3-7.6-6-7-9.2 0-.5 1.7-6.2 5.3-17.3 2.5-1.7 4.4-3.3 5.6-4.7-.1-.1.4-.6.3-.7.3-1.7-1.6-1.4-2.9-1-.6 1.7-2.5 3.4-3.6 4.1-.2.2-1 .6-1 .8l-5.7 17.4c-1.6 5.4 2 9.3 8 12z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191-135.4-.3-1c-1.6-.3-3-.3-4 0 2 1.6 3.3 2 4.2 1z",
    transform: "matrix(.99997 -.0678 -.0678 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66535002,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120-200 .4-1.5c0-.6 0-1.3-.4-1.8-1.3-2.2 1-2.2 2.7-1.4 1.3.6 2.7.3 3.8-.3 1.2-.6 1.8-.5 2.1 0 .3.3.5.6.6 1 .7.5.6 1-.3 1-.9 2.1-2.9 2.8-4.7 3.5-2.6.9-3.2 4.3-4.3-.5z",
    transform: "matrix(0 1 -.99966 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66750002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.1-120c1.9-.7 2 .3 3.3.3-.5-2.8-1-4.3-4-2.8-1.5.8-3.6-.4-4-1.3-.2-.3-1.1.4-1.5 1.1-1.4 3.2 3.7 3.6 6.2 2.7z",
    transform: "matrix(.99818 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66701001,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66705
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.1-71.6a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2-71.6a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.3-72.2a3.4 3.4 0 1 0 0-6.7 3.4 3.4 0 0 0 0 6.7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8-73.4a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.8-90.8a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.6-87.2a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.2-84a3.4 3.4 0 1 0 0-6.9 3.4 3.4 0 0 0 0 6.8zM190.3-96.4a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m257.4-155 12.6 6.3 12.6-6.4-12.6-6.3z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66683,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9 270c0 3.2 1.7 5.7 3.8 5.7 2 0 3.8-2.5 3.8-5.7 0-3-1.7-5.6-3.8-5.6-2.1 0-3.8 2.5-3.8 5.6z",
    transform: "matrix(0 .99538 1 0 0 .1)",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66685998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219-170 12.6 6.3 12.6-6.3-12.6-6.3z",
    transform: "matrix(.99997 -.06114 -.06114 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66558999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-167-231.6c0-3.1-1.6-5.7-3.7-5.7s-3.8 2.6-3.8 5.7 1.7 5.7 3.8 5.7c2 0 3.8-2.6 3.8-5.7z",
    transform: "matrix(-.06085 -.99538 -1 .06112 0 .1)",
    style: {
      fill: "#c6363c",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66562003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m214.8-151.6 13.1-5-10.8-7.2c-2.9.9-5.1 10.5-2.3 12.2z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215-154c3.1.3 5.8-1.1 6-3.2.2-2-2.1-4-5.2-4.3-2-.2-3.3 1.5-3.5 3.4-.2 1.9.6 3.9 2.7 4.1z",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.4-157.4a1.8 1.8 0 1 0 0-3.5 1.8 1.8 0 0 0 0 3.5zM229.3-158.9a1.8 1.8 0 1 0 0-3.5 1.8 1.8 0 0 0 0 3.5zM228.4-150.7a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM256.3-149.6a1.8 1.8 0 1 0 0-3.5 1.8 1.8 0 0 0 0 3.5z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.7 208.5c-.4 1.3 2.6 3.4 2.5 4-1.7.6-5.7-.8-9-3.2-.5-1.6-1.5-1.7-4-2-.6-.2-.1-1.5 1.1-1.6 1.3 0 2 0 3.2.2.4.1.8 0 1.2-.4 1 2.5 2.3 3.1 5 3z",
    transform: "matrix(0 1 .99969 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66760999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3-207.3c.6.3 1 .3 1.9.4.6 0 1.2-.2 1.8-.6.5-.4 1-1 1.3-1.7.3-.4 1-.9 1.7-1.3.7-.3 1.6-.6 2.2-.6 2 0 3.7-.5 4-1.4.2-.5.2-.8 0-1.2-.3 0-.8 0-1.3.4-.6.4-1.3.7-2 .8-.5 0-.8.2-1.8 0-.6 0-.9-.5-1.4-.4-1.2.1-3.4 1-3.4 2.3 0 1.3-.1 2-1.8 2.6-.6.2-.9.5-1.2.7z",
    transform: "matrix(0 1 -.99969 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66760999,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179-155.3 1.2.4c.7.2 1.4.1 2-.2 3-1.4 3.5-7 0-7.7-.7 0-1.3.7-1.6 2a10 10 0 0 1-1.7 4c-.4.7-.4 1.2 0 1.5z",
    transform: "matrix(.99836 -.15239 -.15263 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66272002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4-155.9c3 .7 4.4-5.2 1.5-5.8-1.6-.4-1.4 1.5-1.6 2.5-.1 1.4-2.9 2.6 0 3.3z",
    transform: "matrix(.99846 -.15241 -.15263 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66226,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M180.3-156.8c1.5.4 3-3.2 1-3.7-1.2-.3-2 .5-2.3 1.5-.3 1 .2 2 1.3 2.2z",
    transform: "matrix(.99998 -.15264 -.15264 -1 0 .1)",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65924001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-319-137.1 12.5 6.3 12.6-6.3-12.6-6.3z",
    transform: "matrix(-.99997 -.06114 .06114 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66558999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-133.9 306.5c0-3.2-1.7-5.7-3.8-5.7-2 0-3.8 2.5-3.8 5.7 0 3 1.7 5.6 3.8 5.6 2.1 0 3.8-2.5 3.8-5.6z",
    transform: "matrix(.06085 -.99538 1 .06112 0 .1)",
    style: {
      fill: "#c6363c",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66562003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-325.3-151.6 13.1-5-10.8-7.2c-2.9.9-5 10.5-2.3 12.2z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-325-154c3 .3 5.7-1.1 6-3.2.2-2-2.2-4-5.3-4.3-2-.2-3.3 1.5-3.5 3.4-.2 1.9.6 3.9 2.7 4.1z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-283.7-157.4c1 0 1.7-.8 1.7-1.8a1.8 1.8 0 1 0-1.7 1.8zM-310.7-158.9a1.8 1.8 0 1 0 0-3.5 1.8 1.8 0 0 0 0 3.5zM-311.7-150.7a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zM-283.8-149.6a1.8 1.8 0 1 0 0-3.5 1.8 1.8 0 0 0 0 3.5z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.6-102a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    transform: "matrix(.99998 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222-96.1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    transform: "matrix(.99998 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.4-75.4a3.4 3.4 0 1 0 0-6.9 3.4 3.4 0 0 0 0 6.9z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66680002
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.7-78a3.5 3.5 0 1 0 0-7.1 3.5 3.5 0 0 0 0 7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.5-83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.8-89.3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M271.8-49.8a1.7 1.7 0 0 1 0 3.4 1.7 1.7 0 0 1-3.5 0 1.7 1.7 0 0 1 0-3.4v-3.6h-3a1.7 1.7 0 0 1-3.5 0 1.7 1.7 0 0 1 0-3.4 1.7 1.7 0 0 1 3.5 0h3v-11.8h3.5v11.8h3c0-1 .8-1.7 1.7-1.7 1 0 1.7.8 1.8 1.7a1.7 1.7 0 0 1 0 3.5 1.7 1.7 0 0 1-3.5 0h-3Z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-61a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19z",
    transform: "matrix(.99998 0 0 -1 0 .1)",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66702002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-61h1.8v-7.6h-3.5v7.5l1.8.2z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66715002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.4-68.5a9.5 9.5 0 0 0 0-3.3 279.1 279.1 0 0 1-18.8 0 9.6 9.6 0 0 0 .1 3.3 263.8 263.8 0 0 0 18.7 0z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7-76.4c-2 1.2-2.4-.7-2.4-2.6.2-7.3 1.6-14.2-.3-23.1-.8-3.6-2-5.6-.8-6.3 3.1-1.7 4.5-3.3 4-4.2 1-1.8 3.3-1.4 6.8-.9 3.6-.5 6-.9 6.8.9-.5.9 1 2.5 4.1 4.2 1.3.7 0 2.7-.8 6.3-2 8.9-.5 15.8-.4 23 0 2-.3 4-2.3 2.7-4-2.4-10.7-2.5-14.7 0z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270-103.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-97.2a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-91a3.8 3.8 0 1 0 0-7.5 3.8 3.8 0 0 0 0 7.6zM270-73a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-78.6a3.8 3.8 0 1 0 0-7.5 3.8 3.8 0 0 0 0 7.5z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-84.6a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-194.2-91.5c2.3-.5 4-.5 5.3 0 2.9-4.9 7.8-9.8 14.9-14.8 1-.8 1.6-1 2-.5.2.3-.1 1-1.2 2-3.7 2.9-7 5.3-9.5 7.8-2.2 2.3-3.6 4.5-5.3 7.1-.2.4-.6.4-2.2-.2-1.1-.3-2-.4-2.8 0a.9.9 0 0 0-.4-.5c-.9-.6-1.1-1-.8-.9z",
    transform: "matrix(-.89741 -1 -.99997 .89744 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.49632001,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3 207.7c2.3-.6 4-.6 5.3 0 2.9-5 7.8-9.9 14.8-14.8 1-.8 1.7-1 2-.6.3.3 0 1-1.1 2-3.7 3-7 5.4-9.5 7.9-2.2 2.2-3.7 4.5-5.3 7-.2.4-.7.4-2.2-.1-1.1-.4-2.1-.4-2.8 0a.9.9 0 0 0-.4-.5c-1-.6-1.2-1-.8-1z",
    transform: "matrix(.89741 -1 .99997 .89744 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.49632001,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-274-110.7c-.5-.8-.3-1-.7-1.3-.4-.4-1.2-.4-2-.2-2.8.4-2.4-1.3-1.1-3.3.6-1 2.1-2 2.9-2.8.8-.9.8-1.6 1.2-1.8a71 71 0 0 1 5 0c.3.2.4 1 1.2 1.8.8.8 2.3 1.8 2.9 2.8 1.3 2 1.7 3.7-1.2 3.3-.7-.2-1.5-.2-2 .2-.3.3-.2.5-.7 1.3-.4.6-.8 1-1.3 1.3-.4.3-1 .1-1.4.1-.5 0-1 .2-1.5-.1-.4-.3-.9-.7-1.2-1.3z",
    transform: "matrix(-.99567 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66693997,
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "m269.6 120.2-.5-.1c-.2-2-1-3.8-2.4-5.3 1.5 1 2.6 3.1 2.9 5.4M270.5 120.2l.5-.1c.2-2 1-3.8 2.4-5.3-1.5 1-2.6 3.1-3 5.4",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.7-112.2c-.2-.6-.5-1.3-1-2-1-.8-2.3-.2-3.7 1-.4.3-1.2.5-2 .5-.7 0-1.5-.2-2-.6-1.3-1.1-2.7-1.7-3.6-.8-.5.6-.8 1.3-1 1.9h1.3c.7-.2 1.4-.2 1.9.2.4.3.2.5.8 1.3.3.6.7 1 1.2 1.3.5.3 1 .1 1.4.1.5 0 1 .2 1.5-.1.5-.3.9-.7 1.2-1.3.6-.8.4-1 .8-1.3.4-.4 1.2-.4 2-.2h1.2z",
    strokeMiterlimit: 22.9,
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.7-256.9c-.6-.8-.4-1-.8-1.3-.4-.4-1.2-.4-2-.2-2.8.4-2.4-1.3-1.1-3.3.6-1 2.1-2 2.9-2.8.8-.9.8-1.6 1.1-1.8h5.1c.3.2.4 1 1.2 1.8.7.8 2.2 1.8 2.9 2.8 1.3 2 1.7 3.7-1.2 3.3-.8-.2-1.5-.2-2 .2-.3.3-.2.5-.7 1.3-.4.6-.8 1-1.3 1.3-.4.3-1 .1-1.4.1-.5 0-1 .2-1.5-.1-.4-.3-.9-.7-1.2-1.3z",
    strokeMiterlimit: 22.9,
    transform: "matrix(0 .99572 -1 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66692001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "m266.4 124.3-.1.5c-2 .2-3.8 1-5.3 2.4 1-1.5 3.1-2.6 5.4-3M266.4 123.4l-.1-.5c-2-.3-3.8-1-5.3-2.4 1 1.5 3.1 2.6 5.4 2.9",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-117.2-258.4c-.2-.7-.5-1.3-1-2-.9-.8-2.3-.2-3.7 1-.4.3-1.2.4-2 .4-.7 0-1.5-.1-1.9-.5-1.4-1.1-2.8-1.7-3.6-.8-.6.6-.9 1.2-1.1 1.9h1.3c.7-.2 1.5-.2 2 .2.3.3.1.4.7 1.3.3.6.8 1 1.2 1.3.5.3 1 .1 1.5.1s1 .2 1.4-.1c.5-.3.9-.7 1.2-1.3.6-.9.4-1 .8-1.3.5-.4 1.2-.4 2-.3h1.3z",
    strokeMiterlimit: 22.9,
    transform: "matrix(0 -1 -.99997 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-127 283.2-.8-1.3c-.5-.4-1.2-.4-2-.3-2.9.5-2.5-1.3-1.2-3.2.7-1 2.2-2 3-2.8.7-.9.8-1.6 1.1-1.8h5.1c.3.2.3 1 1.1 1.8s2.3 1.8 3 2.8c1.2 2 1.6 3.7-1.3 3.2-.7 0-1.5 0-2 .3-.3.3-.1.4-.7 1.3-.3.6-.8 1-1.2 1.3-.5.2-1 0-1.5 0s-1 .2-1.4 0c-.5-.3-1-.7-1.3-1.3z",
    strokeMiterlimit: 22.9,
    transform: "matrix(0 -.99572 1 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66692001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "M273.7 123.4v-.5c2.2-.3 3.9-1 5.4-2.4-1 1.5-3.1 2.6-5.4 2.9M273.7 124.3v.5c2.2.2 3.9 1 5.4 2.4-1-1.5-3.1-2.6-5.4-3",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.5 281.7c-.2-.7-.5-1.4-1-2-1-.8-2.3-.2-3.7.9-.4.4-1.2.5-2 .5-.7 0-1.5-.1-2-.5-1.3-1.1-2.7-1.7-3.6-.8-.5.5-.8 1.2-1 1.9h1.3c.7-.2 1.4-.2 2 .2.3.3.1.4.7 1.3.3.6.7 1 1.2 1.3.5.3 1 .1 1.4.1.5 0 1 .2 1.5-.1.4-.3.9-.7 1.2-1.3.6-.9.4-1 .8-1.3.4-.4 1.2-.4 2-.3h1.2z",
    transform: "matrix(0 1 .99997 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-119.6a4.3 4.3 0 1 0 0-8.5 4.3 4.3 0 0 0 0 8.5z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66716999,
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270-120.7a3.2 3.2 0 1 0 0-6.3 3.2 3.2 0 0 0 0 6.3z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66680998,
      strokeOpacity: 1
    },
    transform: "matrix(.99998 0 0 -1 0 .1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270-121.9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
    transform: "matrix(.99998 0 0 -1 0 .1)",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66693002,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "m202.9 127.6.4-.2c-.9-1.2-1-2.3-.7-3.4-.8.9-.6 2.3.3 3.6",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.5-113.1c.7-1 .6-1.1 1-1.4.5-.4 1.2-.2 1.9 0 2.7 1 2.7-1 2-3.5-.5-1.2-1.6-2.5-2.1-3.5s-.4-1.7-.6-2l-2.2-.3-2.2-.2c-.3.1-.6.8-1.5 1.6s-2.4 1.6-3.2 2.5c-1.7 2-2.6 3.8 0 3.7.7 0 1.4.1 1.7.6.2.4 0 .5.2 1.6.2.7.5 1.3.8 1.7.3.4.8.3 1.3.4.4 0 .9.3 1.4 0 .5-.2 1-.6 1.5-1.2z",
    strokeMiterlimit: 22.9,
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "M230 123.8h-.4a13 13 0 0 0-3.5-5.2c1.6.8 3.1 3 4 5.2M230.8 123.7l.5-.1a11 11 0 0 1 .8-6c-1 1.3-1.5 3.8-1.2 6.1",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7-114.2c-.1-.8-.2-1.7-.6-2.4-.6-1.1-2-.7-3.6.4-.5.3-1.3.4-2 .3-.6-.1-1.3-.5-1.6-1-.8-1.4-1.9-2.2-2.9-1.3-.7.5-1.1 1.2-1.5 1.9l1.1.1c.7 0 1.4.1 1.7.6.2.4 0 .5.2 1.6.2.7.5 1.3.8 1.7.3.4.8.3 1.3.4.4 0 .9.3 1.4 0 .5-.2 1-.6 1.5-1.2.7-1 .6-1.1 1-1.4.5-.4 1.2-.2 2 0l1.2.3z",
    strokeMiterlimit: 22.9,
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220-125.3c.4.5.6.4.6.7.1.4-.1 1.1-.4 1.7-1.3 2.5 0 2.3 1.9 1.3.5-.2 1-.7 1.6-1.1.5-.5 1-1 1.5-1.3 1-.7 1.5-.7 1.8-1l.9-2.3.8-2.3c0-.3-.6-.3-1-1-.4-.8-.7-2-1.1-2.7-.7-1-1.4-1.5-1.9-1.4-.5.1-.8.8-1 2.4 0 .6-.4 1.3-.8 1.7-.3.3-.4.2-1.2.6l-1.3 1c-.3.4-.4.9-.5 1.3-.2.4-.5.8-.4 1.2 0 .5.2.8.4 1.2z",
    strokeMiterlimit: 22.9,
    transform: "matrix(1 0 0 -.99584 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.67549002,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "m228.1 127.5.1.5a4.9 4.9 0 0 0-3.3 2.7c.1-.7.5-1.4 1-2a5 5 0 0 1 2.2-1.2M227.8 126.6l-.2-.5c-1 0-1.8-.3-2.6-.7-.9-.3-1.7-.8-2.5-1.4a8.8 8.8 0 0 0 5.3 2.6",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.7-120.7a5 5 0 0 0 1.6-1c.5-.4.7-1 .8-1.6.1-.7 0-1.4-.1-2.2a4 4 0 0 1 .3-2c.2-.7.6-1.5 1-1.9 1.4-1.3 2.4-2.8 2-3.7l-.8-1c-.2.4-.6.7-.7 1.2-.2.8-.5 1.5-.9 2-.3.3-.4.7-1.2 1.2-.6.3-1 .2-1.4.6-.7.9-1.6 3-.7 4 .9 1 1.2 1.4.5 3-.3.6-.3 1-.4 1.4z",
    strokeMiterlimit: 22.9,
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-187.7 182.9c-.3-.8-.1-1-.4-1.2-.4-.4-1-.5-1.7-.5-2.6 0-2-1.4-.5-2.8.8-.8 2.3-1.4 3-2 1-.6 1.1-1.2 1.4-1.3l2.3.2 2.4.3c.2.2.2.8.8 1.6.6.8 2 1.8 2.5 2.8 1 1.9 1.2 3.5-1.7 2.7-.7-.2-1.5-.3-2 0-.4.1-.3.3-1 1-.4.4-.9.8-1.4 1-.5.1-.9-.1-1.4-.2-.5 0-1 0-1.3-.3-.4-.3-.7-.8-1-1.3z",
    strokeMiterlimit: 22.9,
    transform: "matrix(-.3224 -.9955 1 -.32386 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.63440001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "M234.4 125.6v-.5a7.8 7.8 0 0 0 4.3-3c-.7 1.6-2.4 3-4.3 3.5M234.6 126.4l.2.5a9 9 0 0 1 5 1.7 7.7 7.7 0 0 0-5.2-2.2",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.6-132.1c-.6.2-1.2.4-1.8.8-1 .7-.7 2.1.1 3.5.3.5.3 1.3.2 2-.2.8-.5 1.5-.9 1.9-1.3 1.2-2 2.6-1.4 3.6.4.7 1 1 1.6 1.5l.2-1.5c0-.7.2-1.5.6-2 .3-.3.4-.1 1.3-.5a4 4 0 0 0 1.4-1.2c.4-.4.3-.9.4-1.4 0-.5.3-1 0-1.5-.1-.4-.4-.9-.9-1.3-.7-.6-.9-.5-1-.9-.3-.4-.2-1.1 0-1.8.2-.5.2-1 .2-1.2z",
    transform: "matrix(1 0 0 -.99504 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.67695999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.4-122.2c2.2.1 4.4-1.8 4.7-4.2.3-2.4-1.3-4.2-3.4-4.2-2.2 0-4.1 1.7-4.5 4-.5 2.2 1 4.3 3.2 4.4z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.6-123.4c1.6.1 3.2-1.3 3.4-3 .2-1.8-.9-3.1-2.5-3.2-1.5 0-3 1.3-3.3 3-.3 1.7.7 3.2 2.4 3.2z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M230.7-124.5c1 0 2-.9 2.2-2 .2-1-.6-2-1.6-2s-1.9.9-2 2c-.2 1 .4 2 1.4 2z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-312.8-107.7a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    transform: "matrix(-.99998 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66698003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-342.9-115.1a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-346-109.1a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.6zM-349-103a3.3 3.3 0 1 0 0-6.6 3.3 3.3 0 0 0 0 6.5z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-297.6-94.2c1.9 0 1.2-3.4.8-4.1-.6-1-1-1-1.6 0-.4.7-1.1 4 .8 4z",
    transform: "matrix(-.99925 -.06748 .06753 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66689003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-297.4-96c4.5 0 2.8-7.9 1.8-9.6-1.3-2.2-2.3-2.2-3.6 0-1 1.7-2.6 9.5 1.8 9.5z",
    transform: "matrix(-.99997 -.06753 .06753 -1 0 .1)",
    style: {
      fill: "#fff",
      stroke: "#21231e",
      strokeWidth: 0.66535997,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-331.4-13.7c1.8 0 1.2-3.2.7-3.9-.5-.9-1-.9-1.4 0-.4.7-1.1 3.9.7 3.9z",
    transform: "matrix(-.99924 -.31799 .3182 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.63694,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-331.2-15.5c4.3 0 2.7-7.4 1.8-9-1.3-2.1-2.3-2.1-3.5 0-1 1.6-2.5 9 1.7 9z",
    transform: "matrix(-.99997 -.31822 .31821 -1 0 .1)",
    style: {
      fill: "#fff",
      stroke: "#21231e",
      strokeWidth: 0.63547999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-280-79c-9.5 1-19.3 0-29-3.9-8.1-3.2-7.3-12.6 2.6-25.8-.9-1.6-1.4-3.7-1.5-6h2.7c-.7 1.6.1 3.5 1 4.9.6.9.7.7 0 1.7-5.9 8.3-9.8 15.5-7.5 19.9 2.8 5.3 13.7 8 32 7.6l-.1 1.5-.2.2z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-326.3-81.6a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-319.7-79.4a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-318.8-82.3 1-1.4c-5.3-3-7.6-6-7-9.2 0-.5 1.7-6.2 5.3-17.3 2.5-1.7 4.4-3.3 5.6-4.7-.1-.1.4-.6.3-.7.3-1.7-1.6-1.4-2.9-1-.6 1.7-2.5 3.4-3.5 4.1-.3.2-1 .6-1.1.8-2 6.3-4 12-5.6 17.4-1.7 5.4 2 9.3 8 12z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-346.7-99-.3-1c-1.5-.2-2.9-.3-4 0 2 1.7 3.4 2 4.3 1z",
    transform: "matrix(-.99997 -.0678 .0678 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66535002,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120 340.3.4-1.5c0-.6 0-1.3-.4-1.9-1.3-2.1 1-2.1 2.7-1.3 1.3.6 2.7.3 3.8-.3 1.2-.7 1.8-.5 2.1 0l.6.9c.7.6.6 1-.3 1-.9 2.2-2.9 2.9-4.7 3.5-2.6 1-3.2 4.3-4.3-.4z",
    transform: "matrix(0 1 .99966 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66750002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-340-120c2-.7 2.1.3 3.4.3-.5-2.8-1-4.3-4-2.8-1.6.8-3.7-.4-4-1.3-.2-.3-1.2.4-1.5 1.1-1.5 3.2 3.7 3.6 6.2 2.7z",
    transform: "matrix(-.99818 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66701001,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66705
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-283-71.6a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-289.9-71.6a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-296.8-72.2a3.4 3.4 0 1 0 0-6.7 3.4 3.4 0 0 0 0 6.7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-303.2-73.4a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99998 0 0 -1 0 .1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-345.3-90.8a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-339.5-87.2a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-332.9-84a3.4 3.4 0 1 0 0-6.9 3.4 3.4 0 0 0 0 6.8zM-349.9-96.4a3.4 3.4 0 1 0 0-6.8 3.4 3.4 0 0 0 0 6.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.7-331.8c-.4 1.4 2.6 3.5 2.5 4-1.7.6-5.7-.7-9-3.1-.5-1.6-1.5-1.8-4-2.1-.6-.1-.1-1.5 1.1-1.5 1.3 0 2-.1 3.2.2.4 0 .8 0 1.2-.5 1 2.5 2.3 3.2 5 3z",
    transform: "matrix(0 1 -.99969 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66760999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3 333c.6.2 1 .3 1.9.3.6 0 1.2-.2 1.8-.6.5-.4 1-1 1.3-1.6.3-.5 1-1 1.7-1.3.7-.4 1.6-.6 2.2-.7 2 0 3.7-.4 4-1.3.2-.6.2-.8 0-1.3-.3.1-.8.1-1.3.4-.6.4-1.3.8-2 .8-.5 0-.8.3-1.8 0-.6 0-.9-.5-1.4-.4-1.2.2-3.4 1-3.4 2.4 0 1.3-.1 1.9-1.8 2.6-.6.2-.9.5-1.2.7z",
    transform: "matrix(0 1 .99969 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66760999,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-349.7-74.8c.3.3.8.4 1.2.5.7.1 1.4 0 2-.2 3-1.4 3.5-7 0-7.8-.7 0-1.2.7-1.6 2.1a10 10 0 0 1-1.7 4c-.4.7-.3 1.2 0 1.4z",
    transform: "matrix(-.99836 -.15239 .15263 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66272002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-348.2-75.3c3 .6 4.4-5.2 1.5-5.9-1.6-.3-1.4 1.5-1.6 2.6-.1 1.4-2.9 2.6 0 3.3z",
    transform: "matrix(-.99846 -.15241 .15263 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66226,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-347.5-76.2c1.5.3 3-3.3 1-3.8-1.2-.3-2 .5-2.3 1.6-.2 1 .2 2 1.3 2.2z",
    transform: "matrix(-.99998 -.15264 .15264 -1 0 .1)",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65924001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-315.5-102a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    transform: "matrix(-.99998 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-318.1-96.1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    transform: "matrix(-.99998 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309.6-75.4a3.4 3.4 0 1 0 0-6.9 3.4 3.4 0 0 0 0 6.9z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66680002
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-315.4-78a3.5 3.5 0 1 0 0-7.1 3.5 3.5 0 0 0 0 7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-319.6-83a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99998 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-320.3-89.3a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99998 0 0 -1 0 .1)"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "m337.2 127.6-.4-.2c.9-1.2 1-2.3.7-3.4.7.9.6 2.3-.3 3.6",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-309.6-113.1c.7-1 .6-1.1 1-1.4.6-.4 1.3-.2 2 0 2.6 1 2.6-1 1.8-3.5-.3-1.2-1.5-2.5-2-3.5s-.4-1.7-.6-2l-2.2-.3-2.2-.2c-.3.1-.6.8-1.4 1.6-1 .8-2.5 1.6-3.3 2.5-1.7 2-2.6 3.8 0 3.7.7 0 1.4.1 1.7.6.2.4 0 .5.3 1.6.1.7.4 1.3.7 1.7.3.4.8.3 1.3.4.5 0 .9.3 1.4 0 .5-.2 1-.6 1.5-1.2z",
    strokeMiterlimit: 22.9,
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "M310 123.8h.4a13 13 0 0 1 3.5-5.2c-1.5.8-3 3-4 5.2M309.2 123.7l-.4-.1a11 11 0 0 0-.8-6c1 1.3 1.5 3.8 1.2 6.1",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-305.4-114.2c-.1-.8-.2-1.7-.6-2.4-.6-1.1-2-.7-3.6.4-.5.3-1.3.4-2 .3-.6-.1-1.3-.5-1.5-1-1-1.4-2-2.2-3-1.3-.6.5-1 1.2-1.5 1.9l1.2.1c.6 0 1.3.1 1.6.6.2.4 0 .5.3 1.6.1.7.4 1.3.7 1.7.3.4.8.3 1.3.4.5 0 .9.3 1.4 0 .5-.2 1-.6 1.5-1.2.7-1 .6-1.1 1-1.4.6-.4 1.3-.2 2 0l1.2.3z",
    strokeMiterlimit: 22.9,
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-320.1-125.3c.4.5.6.4.7.7 0 .4-.2 1.1-.5 1.7-1.3 2.5 0 2.3 2 1.3l1.5-1.1c.5-.5 1-1 1.5-1.3 1-.7 1.5-.7 1.8-1l.9-2.3.9-2.3c-.1-.3-.6-.3-1-1-.4-.8-.7-2-1.2-2.7-.7-1-1.3-1.5-1.8-1.4-.5.1-.9.8-1 2.4 0 .6-.4 1.3-.9 1.7-.3.3-.3.2-1.1.6-.6.3-1 .7-1.3 1-.4.4-.4.9-.6 1.3-.2.4-.4.8-.4 1.2 0 .5.2.8.5 1.2z",
    strokeMiterlimit: 22.9,
    transform: "matrix(-1 0 0 -.99584 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.67549002,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "m312 127.5-.2.5a4.9 4.9 0 0 1 3.4 2.7c-.1-.7-.5-1.4-1-2a5 5 0 0 0-2.2-1.2M312.3 126.6l.2-.5c1 0 1.8-.3 2.6-.7a12 12 0 0 0 2.5-1.4 8.7 8.7 0 0 1-5.3 2.6",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-320.4-120.7a5 5 0 0 0 1.6-1c.5-.4.7-1 .8-1.6.1-.7 0-1.4-.1-2.2a4 4 0 0 1 .3-2c.2-.7.6-1.5 1-1.9 1.4-1.3 2.4-2.8 2-3.7l-.8-1c-.2.4-.6.7-.7 1.2-.2.8-.5 1.5-.9 2-.3.3-.4.7-1.2 1.2-.6.3-1 .2-1.4.6-.7.9-1.6 3-.7 4 .9 1 1.2 1.4.5 3-.3.6-.3 1-.4 1.4z",
    strokeMiterlimit: 22.9,
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeLinejoin: "round",
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.6-306c-.4-.7-.2-.9-.5-1.1-.3-.4-1-.5-1.7-.5-2.6 0-2-1.4-.4-2.8.7-.8 2.2-1.4 3-2 .8-.6 1-1.2 1.3-1.3a68.4 68.4 0 0 1 4.7.5c.2.2.2.8.8 1.6.7.8 2 1.8 2.5 2.7 1 2 1.2 3.6-1.7 2.8-.7-.2-1.5-.3-2 0-.4.1-.3.3-1 1l-1.3 1c-.5.1-1-.1-1.5-.2-.4 0-1 0-1.3-.3-.4-.3-.7-.8-1-1.3z",
    strokeMiterlimit: 22.9,
    transform: "matrix(.3224 -.9955 -1 -.32386 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.63440001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e"
    },
    d: "M305.6 125.6v-.5a7.8 7.8 0 0 1-4.2-3c.6 1.6 2.3 3 4.2 3.5M305.5 126.4l-.2.5a9 9 0 0 0-5 1.7 7.7 7.7 0 0 1 5.2-2.2",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-297.4-132.1c-.7.2-1.3.4-2 .8-.8.7-.6 2.1.2 3.5.3.5.3 1.3.2 2-.2.8-.5 1.5-.9 1.9-1.3 1.2-2 2.6-1.4 3.6.5.7 1 1 1.6 1.5l.2-1.5c0-.7.2-1.5.6-2 .3-.3.5-.1 1.4-.5a4 4 0 0 0 1.4-1.2c.3-.4.2-.9.3-1.4 0-.5.3-1 .1-1.5-.2-.4-.5-.9-1-1.3-.7-.6-.9-.5-1-.9-.3-.4-.2-1.1 0-1.8l.3-1.2z",
    transform: "matrix(-1 0 0 -.99504 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.67695999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M309.7-122.2c-2.2.1-4.4-1.8-4.7-4.2-.3-2.4 1.3-4.2 3.4-4.2 2.1 0 4.1 1.7 4.5 4 .4 2.2-1 4.3-3.2 4.4z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5-123.4c-1.6.1-3.2-1.3-3.4-3-.2-1.8.9-3.1 2.5-3.2 1.5 0 3 1.3 3.3 3 .3 1.7-.7 3.2-2.4 3.2z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.4-124.5c-1 0-2-.9-2.2-2-.2-1 .5-2 1.5-2s2 .9 2.2 2c.1 1-.5 2-1.6 2z",
    style: {
      fill: "#0c4076",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.6-164.6c1-.2 1.7-.9 1.6-1.6 0-.7-.5-1.4-1.6-1.6l-.9-.1a619.7 619.7 0 0 0-104.2.1c-1.1.2-1.7.9-1.6 1.6 0 .7.5 1.4 1.6 1.6l.9.1a618.8 618.8 0 0 0 104.2-.1z",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.3-167.7a591.2 591.2 0 0 0 77.5 0",
    transform: "matrix(1 0 0 -.99502 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 0.67034,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.3 167.8 12.9.7m51.7 0 13-.7",
    transform: "matrix(1 0 0 .99502 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 0.67034,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.7 175.5h153.1c27.4 0 52.3 10.6 70.3 27.8a92 92 0 0 1 29.2 66.7 92 92 0 0 1-29.2 66.8 101.8 101.8 0 0 1-70.3 27.7h-153z",
    transform: "matrix(0 .99807 1 0 0 .1)",
    style: {
      fill: "#c6363c",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 1.33379996
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#21231e"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.4 270.9c-.1.8 0 2.2-.8 3.3-1 1.3-5.5.8-8.3.7a3734 3734 0 0 0-72.2-2V267.2c33.8-.8 58-1.3 72.2-2 2.8-.1 7.2-.7 8.3.7.9 1 .7 2.5.8 3.3z",
    transform: "matrix(0 .99791 1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66697001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-279.9-412.2c.9.1 2.2-.2 3.4.5 1.4 1 1.6 5.5 1.7 8.3.6 14.3 2 38.2 4.3 71.9-1.2.2-2 .2-2.9.2h-.4c-5.3-33.2-7.4-56.9-11-71.1-.5-2-1.6-7 0-8.5 1-1 2.4-.9 3.2-1.1z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-290.4-410.7c.9 0 2.2-.4 3.4.2 1.5.8 1.5 5.4 2.2 8 3.6 14.3 5.7 38 11 71.3-1 .4-2 .4-2.8.5h-.1c-8.5-32.4-11.1-55.2-17.7-69.3-.7-2-2.3-7.2-.7-9 .9-1 2.3-1 3-1.3z",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.4-169.5c0 .8.3 2.3-.5 3.3-1 1.3-5.6.3-8.3.7-14.9 2.4-36.8-1.4-69.3-2a9 9 0 0 1 0-2.9c0-.7-.3-.6-.1-1.8 32.5-.7 54 2.3 69.5-2.8 2.5-.8 7-.6 8 .7.8 1 .6 2.3.7 3.1z",
    transform: "matrix(.28733 .9979 -1 .28794 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.64093,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.2-412.2c.9.1 2.2-.2 3.3.5 1.5 1 1.6 5.5 1.8 8.3.6 14.3 2 38.2 4.3 71.9-1.2.2-2 .2-2.9.2h-.4c-5.3-33.2-7.4-56.9-11-71.1-.6-2-1.6-7 0-8.5 1-1 2.4-.9 3.2-1.1z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.7-410.7c.8 0 2.2-.4 3.3.2 1.6.8 1.6 5.4 2.3 8 3.6 14.3 5.7 38 11 71.3-1.1.4-2 .4-2.8.5h-.1c-8.6-32.4-11.1-55.2-17.7-69.3-.7-2-2.3-7.2-.7-9 .8-1 2.2-1 3-1.3z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.5 329.2c0 .8.3 2.3-.5 3.3-1.1 1.3-5.6.3-8.3.7-14.9 2.4-36.8-1.4-69.3-2a9 9 0 0 1 0-2.8c0-.8-.3-.7-.1-1.9 32.5-.7 54 2.3 69.5-2.8 2.5-.8 7-.6 8 .7.8 1 .6 2.4.7 3.1z",
    transform: "matrix(-.28733 .9979 1 .28794 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.64093,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-431.8 100c.3-.7.3-1.8 1.2-2.6 1.3-1 5.3-.2 7.9 0 13.6-.5 35.5 3.3 66.6 7.3 0 1-.2 1.7-.5 2.3 0 .7 0 1.4-.3 2.3-31.1-3.2-52.5-8-67.3-4.1-2.4.6-6.8 0-7.6-1.3-.6-.9-.2-2-.2-2.6z",
    transform: "matrix(-.45267 -.99325 1 -.45577 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.60690999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-432.6 156.2c.3-.7.3-1.8 1.2-2.7 1.2-1.1 5.4-.4 8 0 13.7 1.3 36.8 3.3 69.3 6 0 1-.2 1.8-.4 2.5 0 .7 0 1.4-.3 2.4-32.6-1.5-55.8-6.5-69.6-2.8-2.6.7-7 .2-8-1-.6-1-.3-2.2-.4-2.9z",
    transform: "matrix(-.30182 -.99916 1 -.30208 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.63846999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-419 215c0-.7 0-2 .9-2.8 1.2-1.2 5.5-.6 8.3-.4 14 1 37.9 2.4 71.3 4.2.1 1 0 1.8-.2 2.5 0 .8.1 1.5-.1 2.6-33.6-.5-57.7-1.5-71.6-.7-2.8.1-7.2.3-8.2-1-.8-.9-.5-2.1-.6-2.8z",
    transform: "matrix(-.15041 -.99831 1 -.15066 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.6595,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-226.6-347.3c.3-.6.3-1.7 1.2-2.5 1.3-1 5.3-.2 7.9 0 13.6-.5 35.5 3.3 66.6 7.3 0 1-.2 1.7-.4 2.3 0 .7-.1 1.4-.4 2.3-31.1-3.2-52.5-8-67.3-4.1-2.4.6-6.8 0-7.6-1.3-.6-.9-.2-2-.2-2.6z",
    transform: "matrix(.45267 -.99325 -1 -.45577 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.60690999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-283-338.7c.3-.7.3-1.9 1.2-2.7 1.2-1.1 5.4-.4 8 0a4069 4069 0 0 0 69.3 6c0 1-.1 1.8-.4 2.4 0 .7 0 1.5-.2 2.5-32.7-1.5-55.9-6.5-69.7-2.8-2.5.7-7 .2-8-1-.6-1-.3-2.2-.3-3z",
    transform: "matrix(.30182 -.99916 -1 -.30208 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.63846999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-339.4-313c.2-.8.1-2 1-3 1.2-1.1 5.5-.5 8.3-.3 14 1 37.9 2.4 71.3 4.2.1 1 0 1.8-.2 2.6 0 .7.1 1.5-.1 2.5-33.6-.5-57.7-1.5-71.6-.7-2.8.2-7.2.4-8.2-1-.8-.9-.5-2.1-.6-2.8z",
    transform: "matrix(.15041 -.99831 -1 -.15066 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.6595,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 270.8c-.1.7 0 2-.8 3-1.1 1.2-5.6.7-8.4.6-14.3-.6-38.5-1.1-72.5-1.8-.2-1-.1-1.8 0-2.6-.1-.7-.2-1.5 0-2.6 34-.6 58.2-1.1 72.5-1.7 2.8-.1 7.3-.6 8.4.6.8 1 .7 2.2.8 3z",
    transform: "matrix(0 .99304 1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66689003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.6-187.1c-.1.5.1 1.5-.6 2.2-1 1-5.3.7-8 .6-13.7 1.7-37 .6-69.5 0-.2-.8-.2-1.3 0-1.9-.2-.6-.4-1.1-.3-2 32.4 0 55.3 2 69.4-2.6 2.3-.8 7-.6 8 .3.9.7.7 1.7 1 2.2z",
    transform: "matrix(.25239 1 -.993 .25064 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.6473,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3-216.4c-.2.6 0 1.5-.7 2.3-1 1-5.5.6-8.2.6-14.2-.3-38-.4-71.3-.5-.2-.8-.2-1.4 0-2-.2-.5-.3-1-.2-1.9 33.4-1 57.8 1.6 71.2-2.2 2.4-.7 7.1-.6 8.2.3.9.7.7 1.7.9 2.3z",
    transform: "matrix(.16491 .99501 -1 .16573 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.65788001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.9-244.4c-.1.5 0 1.5-.7 2.2-1.1 1-5.5.6-8.3.5a5484 5484 0 0 0-71.9-.8c-.2-.9-.1-1.5 0-2-.1-.6-.2-1.2 0-2 33.6-.7 57.9-.7 71.7-1.8 2.8-.2 7.2-.5 8.3.4.9.7.7 1.7.9 2.3z",
    transform: "matrix(.08204 .99884 -1 .08214 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66468,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.4 324.2c0 .5.2 1.5-.6 2.2-1 1-5.3.7-8 .7-13.6 1.7-36.9.5-69.5 0-.2-.8-.1-1.4 0-2-.2-.5-.3-1.1-.2-2 32.4 0 55.3 2 69.3-2.6 2.3-.8 7-.6 8 .3.9.7.8 1.7 1 2.2z",
    transform: "matrix(-.25239 1 .993 .25064 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.6473,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7 309.3c-.1.5.1 1.5-.7 2.2-1 1-5.4.6-8.2.6-14.1-.3-37.9-.4-71.3-.4-.2-.8-.1-1.4 0-2-.2-.6-.3-1.1-.1-2 33.3-.9 57.7 1.7 71.1-2.2 2.5-.7 7.1-.6 8.3.4.8.7.7 1.6.8 2.2z",
    transform: "matrix(-.16491 .99501 1 .16573 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.65788001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.8 292c-.1.6 0 1.5-.8 2.3-1 1-5.4.6-8.2.5a5478 5478 0 0 0-71.9-.9c-.2-.8-.1-1.4 0-2-.1-.5-.2-1.1 0-2 33.6-.7 57.9-.7 71.7-1.8 2.8-.2 7.2-.5 8.3.5.9.7.7 1.7.9 2.2z",
    transform: "matrix(-.08204 .99884 1 .08214 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66468,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6 270.7c0 .5 0 1.5-.7 2.2-1.1 1-5.5.6-8.3.5-14.3-.4-38.3-.8-72.1-1.3-.2-.9 0-1.5 0-2 0-.6-.2-1.2 0-2 33.8-.5 57.8-1 72-1.4 2.9 0 7.3-.4 8.4.5.8.8.6 1.7.7 2.3z",
    transform: "matrix(0 1 .99988 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.667,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.4 188.1c-.2-1.8.6-4 5.4-11.1 5.3-3.5 10.7-7 15.2-11.5.7-1.4 1.2-2.5 1.4-3.6.3-1.1-1-9.1-1.4-9.3-2.5-2.2-1.4-6.2 1.2-5.3.8-1 4.5.7 3.3 2.6-1.1 1.8.8 7.3.4 9.2 1.6-.9 2-6.1 1.9-9.7-.3-3.2 3-3.4 5.6-2.4 1.2 1.4-.2.3.6.8 2.3 1.2 2.4 4.3.3 4.7-2.1.4-4 8.3-5.6 9.6 3.1-1.8 5.8-5.4 8.9-7.3 1.5-2 1.7-3 5.5-1.2 0 2.4-.7 2.7 1 4 0 3.4-1 4-3.7 3.8-2.8-.2-7.6 2.7-9 3.7-1.2.9-2.6 1.2-3.3 2-1.3 1.4-3.5 7.5-2.5 8.9 1.8 2.5 1.2 4.7-1.5 5.4-.7-.8-4.4.3-4.8-1.6-.3-1.5 0-2.5 1-4 1.6-2.5 2.4-3.7 2.1-4.4-.7-1.7-2.5 3.5-7.8 8.6-7.4 7.1-11.4 8-14.2 8.1z",
    transform: "matrix(.12042 .99535 1 -.12098 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66194999,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.7 136.2c-1.6-2-1.8-3.3-1-4.3.5-.5.2-1-.6-.6-3.3 2-3.3 4.4-1.4 6.3l1.7 1.3c.5-.5 1-2.3 1.3-2.7z",
    transform: "matrix(.15013 .99966 1 -.15019 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65947002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.6-143.5c-1-2.7-.9-5 .3-6 .6-.5.4-1.2-.6-.8-3.8 1.7-4.6 4.5-3.2 7l1.4 1.8c1-.5 2.2-2 2.1-2z",
    transform: "matrix(.21494 1 -.99442 .21375 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.64951998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.7 395.6c2 2.6 3 4.4 2.6 6-.2 1 .3 1.8 1.1.8 3.2-3.7 2.6-7.3-.1-9.4l-2.7-1.5c-.8 1-1 4-.8 4z",
    transform: "matrix(-.9986 .15606 .15628 1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65899003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.1 35.2c0-2.3.7-3.3 2-3.8.8-.3.9-.9 0-.8-6.4 0-6.4 2.8-4.7 6.2 1-.2 2.7-1.5 2.7-1.6z",
    transform: "matrix(.42431 .99781 1 -.42524 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.61368001,
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-84.1-292.8c-.3 1.2.2 1.7.7 1.8 1.2.2 1.2-.5 1.3-2",
    transform: "matrix(.91227 -1 -.99998 -.91229 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.49265999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-82-292.9c-.3 1.3.2 1.8.7 2 1.2.1 1.2-.6 1.3-2.1",
    transform: "matrix(.91227 -1 -.99998 -.91229 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.49265999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-347.2-221c1 1.7 2.3 1.8 3.1 1.4 1.8-1 1-1.8-.7-3.5",
    transform: "matrix(0 -1 -.99656 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.67369002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-344.8-223.6c1.3 1.8 2.7 1.9 3.6 1.4 2-1 1-1.9-.8-3.7",
    transform: "matrix(0 -1 -.99509 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.67677999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-342.1-225.1c1.3 1.6 2.6 2 3.8 1.3 1.8-1.1 1-1.9-.9-3.7",
    transform: "matrix(0 -1 -.99883 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66894001,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-275.1 146c1 1.2 4.6 2 9.5 3.2 8 1.9 13.1.4 15.2-4.6-3.8 3-7.7 4-11.6 2.3-5.3-2.5-8.2-4-9.5-4-1 0-2.5 1.4-3.6 3.1z",
    transform: "matrix(-.99998 -.19529 -.19528 1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65454,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m266-313.7-.1-7.8-6-1.2c0-2.8 6.7-31.3 10.1-31.3 3.5 0 10.2 28.6 10.2 31.3l-6 1.2v7.8c-1.3-1-2.7-2.8-4.2-4.5-1.4 1.7-2.8 3.5-4 4.5z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66680002,
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.7 254-3.1-5.4c1.6-2.2 7.5-4 12.5-.2a37.3 37.3 0 0 0 15.6 7.6c-4.4 3.6-9.1 4.9-13.7 2.7-6.2-2.9-9.8-4.8-11.3-4.8z",
    transform: "matrix(.01547 1 .99997 -.01547 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m325.5 258.4-3.1-5.3c1.5-2.3 7.3-7.1 12.2-3.3 6.2 4.7 11 9.6 15.9 10.7-4.4 3.5-9.1 5-13.7 3-6.3-3-9.8-5.1-11.3-5.1z",
    transform: "matrix(.01547 1 .99997 -.01547 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.3-286-3-5.3c1.5-2.3 7.5-4 12.4-.3a37.4 37.4 0 0 0 15.6 7.7c-4.4 3.5-9 4.8-13.7 2.7-6.2-3-9.7-4.8-11.3-4.8z",
    transform: "matrix(-.01547 1 -.99997 -.01547 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m317.1-281.6-3-5.3c1.5-2.3 7.2-7 12.2-3.3 6.2 4.7 10.9 9.6 15.8 10.7-4.4 3.6-9 5.1-13.7 3-6.2-3-9.7-5-11.3-5z",
    transform: "matrix(-.01547 1 -.99997 -.01547 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m323.1 246.6-3-5.3c1.5-2.3 7.5-4 12.4-.3a37.4 37.4 0 0 0 15.6 7.7c-4.4 3.6-9 4.8-13.7 2.7-6.2-3-9.7-4.8-11.3-4.8z",
    transform: "matrix(.01547 1 .99997 -.01547 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.8-293.4-3.1-5.3c1.5-2.3 7.5-4 12.5-.2a37.3 37.3 0 0 0 15.6 7.6c-4.5 3.6-9.1 4.9-13.7 2.7-6.3-2.9-9.8-4.8-11.3-4.8z",
    transform: "matrix(-.01547 1 -.99997 -.01547 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66685998
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.2 226.8c5 .1 37.7-.8 42.3-1 4.6-.3 7.7-2.3 9.5-4.5-2.7-2-6.4-3.2-10.8-3.5-2.2-.1-33.2.3-39.6.5-9.7 3.6-10 6.3-1.4 8.5z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.2 205.6 45-1.4c4-.4 27.8 4.7 32.5 7.6-3 7-19.2 8.5-34.9 7.2-15.7-1.4-29.3.2-32 1.2-3.6.1-7.4-.5-11-.5.2-4.5.1-9.7.4-14.1z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.6 197.3 45 1c4-.3 27.5 6.1 32 9.2-5.6 7-28.2 5.7-35 4.6a125.4 125.4 0 0 0-32-1l-11.6-.5 1.5-13.3z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.2 191.1-.3 11.8c5-1 20.2-.2 31.8 1.8 11 2 39.2 4.6 46-6.7-15-7-29.4-1.7-42.4-5.2a98 98 0 0 0-35-1.7zM256 236.2c4.8 0 37.6-1.9 42.2-2.3a13 13 0 0 0 9.4-4.8c-2.8-1.9-6.6-3-11-3.1l-39.5 1.6c-9.6 4-10 6.7-1.2 8.6zM229.3 215.2c10.5-.3 33.4-.5 35.3-.4 4.4.2 10 1.9 12.8 3.8a13 13 0 0 1-9.4 4.8c-3.7.3-22.3.4-31.6.5a39.7 39.7 0 0 0-5.5-6.8l-1.6-1.9z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 223.7c11.4-.3 29.3-.1 30.8 0 4.4 0 8.1 1.1 11 3-1.8 2.3-5 4.6-9.6 5-2.8.3-15 1-24.3 1.1-1-3-5.8-6.7-7.8-9.1zM228.3 216.4l-11.6-8c5.7-1.6 46.8-3.6 50.2-1.3 4.4.1 8.1 1.7 11 3.6-1.8 2.3-5 5.6-9.6 4.6s-35.2.1-40 1.1z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2 200c6.3-.4 10.6-.7 12.9-.6 4.4.2 8.1 1.2 10.9 3.1-1.7 2.3-4.8 5-9.4 4.8-17.8-1.1-34.6.8-50.7 3-1.4-1.8-2.9-5-4.3-7 21.7-3.8 35.2-5 40.6-3.3z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.8 192 8.3 2c4.4.2 8 3 10.8 4.9a9.5 9.5 0 0 1-9.1 3.6c-26.3-3.2-43.7-2-65.1 3.4 8.5-12.4 26.4-18.2 55.1-14z",
    style: {
      stroke: "#21231e",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274 192.6 270 181c11.5-1.4 25.9.8 44.8 3.9a95.4 95.4 0 0 0 37.4-.8c-1.7 12.2-17.4 17.3-47 11.2-7.7-1.6-17.7-3.2-31.4-2.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 1 0 0 .1)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M192.2-327.7c.3 7.5-1 15.8-2.4 22.7-2 9.5-3 18.6-3 28.2",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.6-192.1 1.3-7.5L221-197c13.7 2.8 29.9 4.7 47.6 2.6 6.6-.8 12-2.2 16.2-4.3-1 8.2-9 13.5-23 12.8-16.4 1.5-29.5.8-39.2-1.8-3-.8-13.7-3.3-16-4.4z",
    transform: "matrix(0 .99513 -1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66685998,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.4-187.6 4.2-3.6c.8 1 4-.8 10.3.2 3.5.6 7.7 2.7 12.3 3.2 15 1.4 33.8 1.4 45.9-3.1-1 8.2-8.4 11-22.5 11.3-11.6.2-25.3.3-41-2.7-3.8-.5-6.7-2.3-9.2-5.3z",
    transform: "matrix(0 .99513 -1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66685998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.5 252.6 2.4-6.2c6.2 1.9 10.6 3.1 12.7 4a21 21 0 0 1 9 7.5c-2.5 1.5-6 1-10.4-.2-4.6-1.3-9-3.4-13.7-5z",
    transform: "matrix(-.5338 .99821 1 .53476 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.58806998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m249 211.5-.4-6.7c6.1-.6 10.3-1 12.5-1 4.2-.1 8 .7 10.7 2.3a12.8 12.8 0 0 1-8.8 4.9c-4.5.6-9.3.3-14 .5z",
    transform: "matrix(.06514 .99756 1 -.0653 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66547,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m259.3 209-.3-6.7c6-.6 10.2-1 12.4-1 4.3-.1 8 .7 10.7 2.3a12.7 12.7 0 0 1-8.8 4.9c-4.4.6-9.2.2-14 .5z",
    transform: "matrix(.10014 .99756 1 -.10039 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66355997,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m228 224.5-.3-6.7 12.5-1.1c4.3 0 8 .8 10.8 2.4a12.8 12.8 0 0 1-9 4.9c-4.4.6-9.2.2-14 .5z",
    transform: "matrix(-.0159 .99757 1 .01593 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217 221.7-2.8-7.5c5-1 21.5-2.2 28.3 1-1.7 2.4-5 4.8-9.9 5.4-5 .7-10.2.8-15.5 1z",
    transform: "matrix(-.03259 .99785 1 .03266 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66663998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.4 222.2 2-11.6c7-2.2 13-3.5 18.5-3.9-1.4 5.4-4.4 9.1-9.4 10.1-6.7 1.4-9.8 4.5-11 5.4zm0 0",
    transform: "matrix(-.0827 1 .99547 .08232 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.67378998,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66311002
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-216.8 510.3c-4.5 4.6-8.6-6-4.6-20.1 3-10.5 17.3-6.4 9.3 7.6-.4.7-.9.4-.8-.4.4-2.9-1-4.5-3.2-4-6 1.4-6.1 16.1.4 12.8 1.2-.1 0 2.8-1 4z",
    transform: "matrix(-1 0 0 .77147 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 510.3c-4.5 4.6-8.6-6-4.6-20.1 3-10.5 17.4-6.4 9.3 7.6-.3.7-.9.4-.8-.4.5-2.9-1-4.5-3.1-4-6 1.4-6.2 16.1.3 12.8 1.2-.1.1 2.8-1 4z",
    transform: "matrix(1 0 0 .77147 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.7-465a26 26 0 0 0-4.4-7.9c-2.7-3.5-2-9-.2-11.8a24 24 0 0 0 3.2-9.3c.3-1.7.9-5.5.5-11.4a8.2 8.2 0 0 0-2.8-5.6c-.7-.7.3-2.3 2.4-4.3.2-.2.8-.8 1.2-2.2 0-.4 1-.4 1.2 0 .3 1.4 1 2 1.1 2.2 2.2 2 3 3.6 2.4 4.3a8.2 8.2 0 0 0-2.8 5.6c-.3 5.9.2 9.7.5 11.4.4 2.7 1.3 6.2 3.3 9.3 1.8 2.9 2.4 8.3-.2 11.8a26 26 0 0 0-4.5 7.8v.1c0 .5-.2.7-.4.7s-.4-.2-.5-.7z",
    transform: "matrix(1 0 0 -.77147 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.1 221v6.4c0 1.1 1 2 2.4 2 1.3 0 2.3-.9 2.3-2V221c0-1.1-1-2-2.3-2-1.3 0-2.4.9-2.4 2z",
    transform: "matrix(0 .84 1 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66692001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66311002
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-308.5 510.3c-4.5 4.6-8.6-6-4.7-20.1 3-10.5 17.4-6.4 9.4 7.6-.4.7-1 .4-.9-.4.5-2.9-1-4.5-3.1-4-6 1.4-6.2 16.1.3 12.8 1.2-.1.1 2.8-1 4z",
    transform: "matrix(-1 0 0 .77147 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.3 510.3c-4.5 4.6-8.6-6-4.6-20.1 3-10.5 17.3-6.4 9.3 7.6-.4.7-1 .4-.8-.4.4-2.9-1-4.5-3.2-4-6 1.4-6.1 16.1.3 12.8 1.2-.1.2 2.8-1 4z",
    transform: "matrix(1 0 0 .77147 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.5-465a26 26 0 0 0-4.5-7.9c-2.6-3.5-2-9-.2-11.8a24 24 0 0 0 3.3-9.3c.3-1.7.8-5.5.4-11.4a8.2 8.2 0 0 0-2.8-5.6c-.6-.7.3-2.3 2.4-4.3.3-.2.9-.8 1.2-2.2.1-.4 1.1-.4 1.2 0 .3 1.4 1 2 1.2 2.2 2.1 2 3 3.6 2.4 4.3a8.2 8.2 0 0 0-2.8 5.6c-.4 5.9.1 9.7.4 11.4a24 24 0 0 0 3.3 9.3c1.8 2.9 2.4 8.3-.2 11.8a26 26 0 0 0-4.5 7.8v.1c0 .5-.2.7-.4.7s-.4-.2-.4-.7z",
    transform: "matrix(1 0 0 -.77147 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M458.1 312.7v6.5c0 1 1 2 2.4 2 1.3 0 2.3-1 2.3-2v-6.5c0-1.1-1-2-2.3-2-1.3 0-2.4.9-2.4 2z",
    transform: "matrix(0 .84 1 0 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66692001,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      strokeWidth: 0.66685998
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.2-313.3c5 .1 37.7-.7 42.3-1 4.6-.3 7.7-2.3 9.5-4.5-2.7-2-6.4-3.2-10.8-3.5-2.2-.1-33.2.3-39.6.5-9.7 3.6-10 6.4-1.4 8.5z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.2-334.5 45-1.4c4-.4 27.8 4.8 32.5 7.6-3 7-19.2 8.5-34.9 7.2-15.7-1.3-29.3.2-32 1.3-3.6 0-7.4-.5-11-.6.2-4.4.1-9.6.4-14.1z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m263.6-342.8 45 1c4-.3 27.5 6.1 32 9.2-5.6 7.1-28.2 5.7-35 4.6a125.4 125.4 0 0 0-32-1c-3.6-.2-7.9-.2-11.6-.5l1.5-13.3z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.2-349-.3 11.8c5-1 20.2-.2 31.8 1.8 11 2 39.2 4.6 46-6.7-15-7-29.4-1.7-42.4-5.2a98 98 0 0 0-35-1.7zM256-303.9c4.8 0 37.6-1.9 42.2-2.3a13 13 0 0 0 9.4-4.8c-2.8-1.9-6.6-3-11-3-2.2-.2-33.2 1.2-39.5 1.5-9.6 4-10 6.7-1.2 8.6zM229.3-324.8c10.5-.4 33.4-.5 35.3-.5 4.4.2 10 2 12.8 3.8a13 13 0 0 1-9.4 4.8c-3.7.3-22.3.4-31.6.5a39.6 39.6 0 0 0-5.5-6.8l-1.6-1.8z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236-316.4c11.4-.2 29.3-.1 30.8 0 4.4.1 8.1 1.2 11 3-1.8 2.3-5 4.7-9.6 5-2.8.3-15 1.1-24.3 1.2-1-3-5.8-6.8-7.8-9.2zM228.3-323.7l-11.6-8c5.7-1.6 46.8-3.6 50.2-1.3 4.4.2 8.1 1.8 11 3.7-1.8 2.2-5 5.5-9.6 4.6-4.6-1-35.2 0-40 1z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.2-340.1c6.3-.4 10.6-.7 12.9-.6 4.4.2 8.1 1.2 10.9 3.2-1.7 2.2-4.8 5-9.4 4.7-17.8-1.1-34.6.8-50.7 3.1-1.4-2-2.9-5.1-4.3-7 21.7-3.8 35.2-5.1 40.6-3.4z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.8-348.2 8.3 2.2c4.4.2 8 2.9 10.8 4.8a9.5 9.5 0 0 1-9.1 3.7c-26.3-3.3-43.7-2.1-65.1 3.4 8.5-12.5 26.4-18.2 55.1-14z",
    style: {
      stroke: "#21231e",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274-347.5 270-359c11.5-1.5 25.9.8 44.8 3.8a95.4 95.4 0 0 0 37.4-.7c-1.7 12.1-17.4 17.3-47 11.2-7.7-1.6-17.7-3.2-31.4-3z",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(0 .99513 -1 0 0 .1)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-347.9-327.7c.3 7.5-1 15.8-2.4 22.7-2 9.5-3 18.6-3 28.2",
    transform: "matrix(-.99997 0 0 -1 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m206.6 348 1.3-7.5L221 343c13.7 2.8 29.9 4.7 47.6 2.5 6.6-.7 12-2.1 16.2-4.2-1 8.2-9 13.5-23 12.8-16.4 1.4-29.5.8-39.2-1.8-3-.8-13.7-3.3-16-4.4z",
    transform: "matrix(0 .99513 1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66685998,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.4 352.5 4.2-3.7c.8 1 4-.7 10.3.3 3.5.6 7.7 2.7 12.3 3.1 15 1.5 33.8 1.5 45.9-3-1 8.2-8.4 11-22.5 11.3-11.6.2-25.3.2-41-2.7-3.8-.6-6.7-2.3-9.2-5.3z",
    transform: "matrix(0 .99513 1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66685998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.5-167.3 2.4-6.3c6.2 1.9 10.6 3.2 12.7 4a21 21 0 0 1 9 7.6c-2.5 1.4-6 1-10.4-.3-4.6-1.3-9-3.4-13.7-5z",
    transform: "matrix(.5338 .99821 -1 .53476 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.58806998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.7-326.3-.3-6.7c6.1-.6 10.3-1 12.4-1 4.3-.1 8 .7 10.8 2.3a12.8 12.8 0 0 1-8.8 4.9c-4.5.6-9.3.3-14 .5z",
    transform: "matrix(-.06514 .99756 -1 -.0653 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66547,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.5-325.7-.3-6.7c6-.6 10.2-1 12.4-1 4.3-.1 8 .7 10.7 2.3a12.7 12.7 0 0 1-8.8 4.9c-4.4.6-9.2.3-14 .5z",
    transform: "matrix(-.10014 .99756 -1 -.10039 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66355997,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.7-315.4-.4-6.7c6.2-.7 10.3-1.1 12.5-1.1 4.3-.1 8 .7 10.8 2.4a12.8 12.8 0 0 1-8.9 4.8c-4.5.6-9.3.3-14 .6z",
    transform: "matrix(.0159 .99757 -1 .01593 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66680002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m234.7-317.8-2.8-7.5c5-1 21.4-2.2 28.3 1-1.8 2.4-5 4.8-10 5.4-5 .7-10.2.8-15.5 1z",
    transform: "matrix(.03259 .99785 -1 .03266 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66663998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m241.8-316.6 2-11.7c6.9-2.1 13-3.4 18.4-3.8-1.4 5.3-4.4 9-9.3 10-6.7 1.4-9.9 4.5-11.1 5.5zm0 0",
    transform: "matrix(.0827 1 -.99547 .08232 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.67378998,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6-232.4c1 .1 1.8.4 2.8.7-4.3 2.7-7.9 6-12.1 12.5-4.4 6.6 1.9 18.5 4.4 24.8 5.4 4 10.4 9.8 12 17.5.7 4.1-10.7 2.6-18.6-1-9.6-4.6-10.9-3.3-14.3-4-1.2-6 1.3-6.5 3.8-6.2a60.6 60.6 0 0 1-8.6-29 60.6 60.6 0 0 1-8.5 29c2.4-.3 5 .2 3.8 6.1-3.4.8-4.7-.5-14.3 4-7.9 3.7-19.3 5.2-18.6 1.1a29.8 29.8 0 0 1 12-17.5c2.5-6.3 8.8-18.2 4.4-24.8a37.4 37.4 0 0 0-12-12.5l2.7-.8c-.7-.8-6.3-2.6-7-2.1-4.2 3-8.4 10-12 14.2-10.3 11.7-15.4 20.7-13.6 28 2.6 7.8 11.8 16.5-.4 15-12.2-1.5-22.4-18.2-25.6-38.4-1.2-7.5-2-13.7-2.7-18.8 6.6 2.3 9.6 4.7 11.4 7.6-.8-2.7-1.4-5.4-1.8-7.9 5.4 1 9.4 3.6 10.8 8.5.6 2 1.3 3.7 2 5 1.7-.6 3.9-.5 6.5.1 1-2.4 8.5-10.8 12.5-16.9 4.6-7 11.5-12.2 13.7-12.5 1.1-.2 1.5 2.3 1.2 5.8 12-.1 23.9-.2 35.5.2 11.7-.4 23.6-.3 35.5-.2-.2-3.5.1-6 1.3-5.8 2.2.3 9 5.6 13.6 12.5 4 6.1 11.6 14.5 12.6 16.9 2.6-.6 4.8-.7 6.5 0 .7-1.4 1.4-3 2-5 1.4-5 5.4-7.6 10.8-8.6-.4 2.5-1 5.2-1.8 8 1.8-3 4.7-5.4 11.4-7.7-.8 5-1.5 11.3-2.7 18.8-3.3 20.2-13.4 36.9-25.6 38.4-12.2 1.5-3-7.2-.4-15 1.8-7.3-3.3-16.3-13.6-28-3.7-4.1-7.8-11.2-12-14.2-.7-.5-6.3 1.3-7 2.2z",
    transform: "matrix(.99997 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.1 247.6c1 1.2 4.6 2 9.5 3.2 8 1.9 13.2.3 15.2-4.6-3.7 3-7.7 4-11.6 2.3-5.2-2.5-8.2-4-9.5-4-.9 0-2.4 1.3-3.6 3.1z",
    transform: "matrix(.99998 -.19529 .19528 1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65454,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313 178.3c9.4 1 9 7.2.2 15.9-1.7 1.6-2.3 1.6-2.6-.1-.6-3-4-4.8-5.7-2.5-1.2 1.5-1 2.4-5 1.9-5 4.2-9 7.1-2.4 6.9 2.8-.1 5 1.6 8.8 1.4-1 2.2-1.3 2.4-1.9 2.6-3.6.7-7.5-1.5-11.2-.9-8 1.5 13-21.8 12.7-22.7-.7-2.4 5-6.6 7.1-2.5z",
    transform: "matrix(1 0 0 .99686 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.67334998,
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-312.8-178c.8-2.3 2.2-4.3 4.4-6.2",
    transform: "matrix(-1 0 0 -.99706 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 0.67295003,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e",
      fillRule: "evenodd"
    },
    d: "M314.8 182c0-.4-.4-.7-.9-.6-.4 0-.7.4-.6.8 0 .4.4.8.8.7.5 0 .8-.4.7-.8",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.7-112c2.3.7 5 .3 8.4 0 1-.2 4.4-.6 5.3-.2",
    transform: "matrix(.99998 .25807 .25806 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.86079001,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-292 92c2.7.5 4.1.6 5.4.7",
    transform: "matrix(-.99997 -.32891 -.3289 1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.63349003,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.2 53.7c1.6-.3 3.8-.9 5.7-.1 1.3.5 1.4 2.4.5 4.4",
    transform: "matrix(.81664 1 .99997 -.81667 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.68856001,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e",
      fillRule: "evenodd"
    },
    d: "m240.4 185.2-1.2-1.3c-.6-.7-.3-1.7 1-3l2.5 1c-.5 1.8-1.3 2.8-2.3 3.3",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.5-270.3c1.7-.3 4-.9 5.8-.1 1.3.5 1.4 2.4.5 4.4",
    strokeMiterlimit: 22.9,
    transform: "matrix(-.81664 1 -.99997 -.81667 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 0.68856001,
      strokeMiterlimit: 22.9260006,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e",
      fillRule: "evenodd"
    },
    d: "m299.7 185.2 1.2-1.3c.6-.7.3-1.7-1-3l-2.5 1c.5 1.8 1.3 2.8 2.3 3.3",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeLinecap: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-242.7-242.8c2.3.8 5 .4 8.4 0 1 0 4.4-.5 5.3 0",
    transform: "matrix(-.99998 .25807 -.25806 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.86079001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.4 252.4c2.6.4 4.1.5 5.4.6",
    transform: "matrix(.99997 -.32891 .3289 1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.63349003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66688001,
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.7-231.7c5.4-1.9 10.2-1.5 13.8 2l1.7 1.7",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.8-224.7a33 33 0 0 0-2.7-9.4c3.8 1 6.8 2.7 8.6 5.3M270-235.8c-3 3.6-4.8 7.7-5 12.3",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258-224.2c.3-3.6 1.3-6.7 3-9.1 1.8 1.4 3.5 3.6 4.4 6.8",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-303.4-231.7c5.4-1.9 10.2-1.5 13.8 2l1.7 1.7",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-287.3-224.7a33 33 0 0 0-2.7-9.4c3.8 1 6.8 2.7 8.6 5.3",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-282.1-224.2c.3-3.6 1.3-6.7 3-9.1 1.8 1.4 3.6 3.6 4.4 6.8",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-270.1-235.8c-3 3.6-4.8 7.7-5 12.3",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    },
    transform: "matrix(-.99997 0 0 -1 0 .1)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.66685998
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.3-200.4c3 4.2 25 12 31.5 12.6 15 1.4 33.4 1.3 45.3-3.1",
    transform: "matrix(0 .99513 -1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.3 339.6c3 4.3 25 12 31.5 12.7 15 1.4 33.4 1.3 45.3-3.1",
    transform: "matrix(0 .99513 1 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M-227 178.3c9.3 1 8.9 7.2.1 15.9-1.7 1.6-2.2 1.6-2.6-.1-.6-3-4-4.8-5.7-2.5-1.2 1.5-1 2.4-4.9 1.9-5 4.2-9 7.1-2.5 6.9 2.9-.1 5 1.6 8.8 1.4-1 2.2-1.3 2.4-1.9 2.6-3.6.7-7.5-1.5-11.1-.9-8 1.5 12.9-21.8 12.6-22.7-.6-2.4 5-6.6 7.2-2.5z",
    transform: "matrix(-1 0 0 .99686 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#21231e",
      strokeWidth: 0.67334998,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.3-178c.7-2.3 2.2-4.3 4.4-6.2",
    transform: "matrix(1 0 0 -.99706 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 0.67295003,
      strokeLinecap: "round",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21231e",
      fillRule: "evenodd"
    },
    d: "M225.3 182c0-.4.4-.7.9-.6.4 0 .7.4.6.8 0 .4-.4.8-.9.7a.7.7 0 0 1-.6-.8",
    transform: "translate(0 .1)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "#21231e",
      strokeMiterlimit: 22.9260006
    },
    strokeMiterlimit: 22.9
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-45 349.2-2.7-4.7c1.4-2 6.7-3.5 11-.2 5.5 4.1 9.4 5.8 13.8 6.8-4 3-8 4.2-12.1 2.3-5.5-2.5-8.6-4.2-10-4.2z",
    transform: "matrix(-.99998 .5396 .53958 1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.58688998,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m174.4 320.3.3-6.5c5.6 0 9.4-.2 11.3 0 3.9.3 7.1 1.4 9.5 3.2-1.6 2-4.4 3.8-8.4 4-4 .2-8.4-.5-12.7-.7z",
    transform: "matrix(-.47247 1 .99997 .47249 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.60295999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268 292.7.3-7c6.1-.2 10.2-.2 12.3 0 4.2.2 7.7 1.5 10.3 3.4-1.7 2.2-4.7 4.1-9.1 4.3-4.4.2-9.1-.6-13.8-.7z",
    transform: "matrix(-.19727 1 .99998 .19727 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.65426999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344-190.3.6-4.2c1.6-2.3 7.5-4 12.4-.3a37 37 0 0 0 15.4 7.6c-4.4 3.5-9 4.8-13.5 2.7a81.4 81.4 0 0 0-14.9-5.9z",
    transform: "matrix(.14684 1 -.99997 .14685 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.65979999,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m184.8 317.5.3-6.7c5.7-.1 9.6-.2 11.6 0 4 .3 7.3 1.4 9.7 3.3-1.6 2-4.3 4.3-8.4 4.5-4.2.2-8.8-1-13.2-1.1z",
    transform: "matrix(-.40408 1 .99997 .4041 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.61830997,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.6 297.8-3.7-6.1c.7-1 3.7 0 6 .3.5 0 1 0 1.5.2 1.2.3 2.3.9 3.4 1.7 4.7 3.6 8 4.7 11.9 5.5-3.4 2.7-7 3.7-10.5 2-4.8-2.1-7.4-3.6-8.6-3.6z",
    transform: "matrix(-.99997 .84188 .84187 1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.51016003,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#edb92f"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.7-344.2c-.2-1.8.6-4 5.4-11.1 5.3-3.5 10.7-7 15.2-11.5a15 15 0 0 0 1.4-3.6c.3-1.1-1-9.1-1.4-9.3-2.5-2.2-1.4-6.2 1.2-5.2.8-1.1 4.5.6 3.3 2.5-1.1 1.8.8 7.3.4 9.2 1.6-.9 2-6 1.9-9.7-.3-3.2 3-3.4 5.6-2.3 1.2 1.4-.2.3.6.7 2.3 1.2 2.4 4.3.3 4.7-2.1.4-4 8.3-5.6 9.6 3.1-1.8 5.8-5.3 8.9-7.3 1.5-2 1.7-3 5.5-1.2 0 2.4-.7 2.7 1 4 0 3.4-1 4-3.7 3.8-2.8-.2-7.6 2.7-9 3.7-1.2.9-2.6 1.2-3.3 2-1.3 1.4-3.5 7.5-2.5 8.9 1.8 2.6 1.2 4.7-1.5 5.4-.7-.8-4.4.3-4.8-1.5-.3-1.6 0-2.5 1-4.1 1.6-2.4 2.4-3.7 2.1-4.4-.7-1.7-2.5 3.5-7.8 8.6-7.4 7.2-11.4 8-14.2 8.1z",
    transform: "matrix(-.12042 .99535 -1 -.12098 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.66194999,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.4-392c-1.7-2-1.8-3.2-1-4.2.5-.6.1-1.2-.7-.7-3.2 2-3.3 4.4-1.3 6.3l1.7 1.3c.4-.4 1-2.3 1.3-2.6z",
    transform: "matrix(-.15013 .99966 -1 -.15019 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65947002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.7 375.6c-1.1-2.7-1-4.9.2-5.9.6-.5.4-1.2-.5-.8-3.9 1.6-4.7 4.4-3.2 7l1.3 1.8c1-.6 2.2-2 2.2-2.1z",
    transform: "matrix(-.21494 1 .99442 .21375 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.64951998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.3 313.2c1.9 2.6 3 4.4 2.6 6-.3 1 .3 1.8 1 .9 3.2-3.8 2.7-7.4 0-9.4l-2.7-1.6c-.8 1-1 4-.9 4.1z",
    transform: "matrix(.9986 .15606 -.15628 1 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.65899003,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.2-422.2c0-2.2.7-3.3 2-3.8.8-.2.9-.8 0-.7-6.4 0-6.4 2.7-4.8 6.1 1-.2 2.8-1.5 2.8-1.6z",
    transform: "matrix(-.42431 .99781 -1 -.42524 0 .1)",
    style: {
      fill: "#edb92e",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 0.61368001,
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-353 2c-.3 1.2.2 1.7.7 1.8 1.2.2 1.2-.6 1.3-2",
    transform: "matrix(-.91227 -1 .99998 -.91229 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.49265999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-351 2c-.2 1.1.3 1.7.8 1.8 1.2.2 1.2-.6 1.3-2",
    transform: "matrix(-.91227 -1 .99998 -.91229 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.49265999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-347.2 321c1 1.7 2.3 1.8 3.1 1.3 1.8-.9 1-1.8-.7-3.5",
    transform: "matrix(0 -1 .99656 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.67369002,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-344.8 319.2c1.3 1.7 2.7 1.8 3.6 1.4 2-1 1-2-.8-3.8",
    transform: "matrix(0 -1 .99509 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.67677999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-342.1 315.6c1.3 1.6 2.6 2 3.8 1.3 1.8-1.1 1-1.9-.9-3.7",
    transform: "matrix(0 -1 .99883 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66894001,
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.4 123.5-2.8-4.7c1.4-2 6.7-3.5 11-.2 5.5 4.1 9.4 5.8 13.8 6.8-4 3-8 4.2-12.1 2.3-5.5-2.5-8.6-4.2-10-4.2z",
    transform: "matrix(.99998 .5396 -.53958 1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.58688998,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383-121.2.3-6.5c5.6-.1 9.4-.2 11.4 0 3.8.3 7 1.4 9.4 3.2-1.6 2-4.4 3.8-8.4 4-4 .2-8.4-.6-12.7-.7z",
    transform: "matrix(.47247 1 -.99997 .47249 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.60295999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.6-227.2.3-7c6-.1 10.2-.2 12.3 0 4.2.3 7.7 1.5 10.3 3.5-1.8 2-4.8 4-9.2 4.3-4.4.2-9-.6-13.7-.8z",
    transform: "matrix(.19727 1 -.99998 .19727 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.65426999,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.4 338.3.6-4.1c1.5-2.3 7.4-4 12.3-.3a37 37 0 0 0 15.5 7.6c-4.4 3.5-9 4.8-13.6 2.7a81.4 81.4 0 0 0-14.8-5.9z",
    transform: "matrix(-.14684 1 .99997 .14685 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.65979999,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.4-146.8.3-6.7c5.8 0 9.6-.2 11.7 0 4 .3 7.2 1.5 9.7 3.3-1.7 2-4.3 4.3-8.5 4.5-4.2.2-8.7-1-13.2-1.1z",
    transform: "matrix(.40408 1 -.99997 .4041 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.61830997,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m328.6 31.7-3.6-6.1c.7-1 3.7 0 6 .3.4 0 1 0 1.5.2 1.1.3 2.3.9 3.3 1.7 4.8 3.6 8.2 4.7 12 5.5-3.4 2.7-7 3.7-10.5 2-4.8-2.1-7.5-3.6-8.7-3.6z",
    transform: "matrix(.99997 .84188 -.84187 1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.51016003,
      strokeLinejoin: "round",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-323.3-236.5v-61a39.6 39.6 0 0 1 39.7-39.8 39.6 39.6 0 0 1 39.7 39.7v61.1z",
    transform: "matrix(-.95223 0 0 -1 0 .1)",
    style: {
      fill: "#c6363c",
      fillOpacity: 1,
      stroke: "#21231e",
      strokeWidth: 1.33379996,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#fff"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M324-274v-15.7h-31.5v-46.7a39.7 39.7 0 0 0-16.6 0v46.7h-31.4v15.7H276v37.5h16.5V-274z",
    transform: "matrix(.94998 0 0 -1 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.66688001,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd",
      strokeLinejoin: "round"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-245.4-257.6h-22.2c-1.3 4.8-6 16.6 4.3 17.2 4.8.3 8-6 3.7-7.6-2-.8-3.4 0-3.8 1.2-.5 1.3.5 2.5 2 2.2-2.6 5-8.2-4.5-1-8.7 2.2-1.3 4.4 2 6 2 1.5 0 3.8-3.2 5.8-2 7.1 4.3 1.6 13.7-1 8.7 1.5.3 2.6-.9 2-2.2-.4-1.1-1.8-2-3.8-1.2-4.2 1.7-1 7.9 3.7 7.6 10.3-.6 5.6-12.4 4.3-17.2z",
    transform: "matrix(0 -1 -.99769 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeWidth: 0.67624998,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 0.67137998
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-245.4 283.7h-22.2c-1.3 4.8-6 16.6 4.3 17.2 4.8.3 8-5.9 3.7-7.6-2-.7-3.4.1-3.8 1.3-.5 1.2.5 2.5 2 2.1-2.6 5-8.2-4.4-1-8.7 2.2-1.3 4.4 2.1 6 2.1 1.5 0 3.8-3.3 5.8-2.1 7.1 4.3 1.6 13.8-1 8.7 1.5.4 2.6-.9 2-2.1-.4-1.2-1.8-2-3.8-1.3-4.2 1.7-1 7.9 3.7 7.6 10.3-.6 5.6-12.4 4.3-17.2z",
    transform: "matrix(0 -1 .99769 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3-257.6H296c-1.3 4.8-6 16.6 4.3 17.2 4.8.3 7.9-6 3.7-7.6-2-.8-3.4 0-3.8 1.2-.5 1.3.5 2.5 2 2.2-2.6 5-8.2-4.5-1-8.7 2.2-1.3 4.3 2 6 2 1.5 0 3.8-3.2 5.8-2 7.1 4.3 1.6 13.7-1 8.7 1.5.3 2.5-.9 2-2.2-.4-1.1-1.8-2-3.8-1.2-4.2 1.7-1 7.9 3.7 7.6 10.3-.6 5.6-12.4 4.3-17.2z",
    transform: "matrix(0 1 -.99769 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3 283.7H296c-1.3 4.8-6 16.6 4.3 17.2 4.8.3 7.9-5.9 3.7-7.6-2-.7-3.4.1-3.8 1.3-.5 1.2.5 2.5 2 2.1-2.6 5-8.2-4.4-1-8.7 2.2-1.3 4.3 2.1 6 2.1 1.5 0 3.8-3.3 5.8-2.1 7.1 4.3 1.6 13.8-1 8.7 1.5.4 2.5-.9 2-2.1-.4-1.2-1.8-2-3.8-1.3-4.2 1.7-1 7.9 3.7 7.6 10.3-.6 5.6-12.4 4.3-17.2z",
    transform: "matrix(0 1 .99769 0 0 .1)",
    style: {
      stroke: "#21231e",
      strokeOpacity: 1
    }
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M-323.3-236.5v-61a39.6 39.6 0 0 1 39.7-39.8 39.6 39.6 0 0 1 39.7 39.7v61.1z",
    transform: "matrix(-.95223 0 0 -1 0 .1)",
    style: {
      fill: "none",
      stroke: "#21231e",
      strokeWidth: 1.33379996,
      strokeOpacity: 1
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrb);
export default __webpack_public_path__ + "static/media/srb.06bb31fefeb56374d0d193b9f188e7fe.svg";
export { ForwardRef as ReactComponent };